export class Instruction {
    question: string;
    title: string;
    body: string;
    }
